import { Grid, MenuItem } from "@mui/material";
import { Form, Formik } from "formik";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { normalizeString } from "../../../../../../../util/stringUtils";
import FormikActions from "../../../../../../commons/formik/FormikActions";
import FormikAutocomplete from "../../../../../../commons/formik/FormikAutocomplete";
import FormikSelect from "../../../../../../commons/formik/FormikSelect";
import FormikTextField from "../../../../../../commons/formik/FormikTextField";
import RequeridoLabel from "../../../../../../commons/labels/RequeridoLabel";
import { StyledResolucion } from "../../../../../../styled/Prevencion";
import { sustanciasForm1Validation } from "../formValidations";
import EquipoRadiologicoTableContainer from "../part2/equipoRadiologico/EquipoRadiologicoTableContainer";
import EstudiosAmbientalesTableContainer from "../part4/EstudiosAmbientalesTableContainer";
import ProveedoresTableContainer from "./proveedores/ProveedoresTableContainer";
import UsosTableContainer from "./usos/UsosTableContainer";

const specialSubstancesNames = [
  "radiacionultravioleta",
  "virusdelahepatitisb(infeccioncronica)",
  "virusdelahepatitisc(infeccioncronica)",
  "humodetabacoajeno"
];

const isSpecialSubstance = (sustanciaNombre) => {
  if (!sustanciaNombre) return false;

  const normalizedSustancia = normalizeString(sustanciaNombre);
  return specialSubstancesNames.some((s) => normalizedSustancia.includes(s));
};


const DatosSustanciaForm = ({
  formModel,
  handleCancelSustancia,
  stepper,
  handleSubmit,
  sustanciasAgregadas,
  sustancia,
}) => {
  const sustancias = useSelector((state) => state.resolucion.sustancias.data);
  const usos = useSelector((state) => state.resolucion.abmSustancia.usos);
  const unidadesDeMedida = useSelector((state) => state.resolucion.unidadDeMedida.data);
  const hayUsoSinMedicion = usos.some((uso) => uso.sinMedicion);

  const handleFormSubmit = (values) => {
    if (!usos || usos.length === 0) {
      toast.error("Debe agregar al menos un Origen/Uso antes de continuar");
      return;
    }
    handleSubmit(values);
  };

  return (
    <Formik
      initialValues={formModel}
      enableReinitialize={true}
      onSubmit={handleFormSubmit}
      validationSchema={sustanciasForm1Validation(sustanciasAgregadas, sustancia, hayUsoSinMedicion)}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <StyledResolucion.GridContainer container spacing={3}>
            <StyledResolucion.RowContainer item xs={12} container>
              <StyledResolucion.RowContainer item xs={12} container>
                <StyledResolucion.RowContainer item xs={12}>
                  <StyledResolucion.FormikInput>
                    <FormikAutocomplete
                      name="sustancia"
                      label="Código Sustancia - Descripción"
                      options={sustancias}
                      callBack={(value) => {
                        if (value) {
                          if (isSpecialSubstance(value.nombre)) {
                            setFieldValue("nombre", "NO APLICA");
                            setFieldValue("esSubstanciaEspecial", true);
                          } else {
                            setFieldValue("nombre", "");
                            setFieldValue("esSubstanciaEspecial", false);
                          }
                        }
                      }}
                    />
                  </StyledResolucion.FormikInput>
                </StyledResolucion.RowContainer>
              </StyledResolucion.RowContainer>


              <StyledResolucion.RowContainer item xs={8}>
                <StyledResolucion.FormikInput>
                  <FormikTextField
                    name="nombre"
                    label="Nombre Comercial"
                    fullWidth
                    disabled={values.sustancia === null || values.esSubstanciaEspecial}
                  />
                </StyledResolucion.FormikInput>
              </StyledResolucion.RowContainer>
              <StyledResolucion.RowContainer item xs={4}>
                <RequeridoLabel
                  text={'Si no posee o no se comercializa debe colocar "NO APLICA"'}
                />
              </StyledResolucion.RowContainer>
            </StyledResolucion.RowContainer>

            <StyledResolucion.RowContainer item xs={12} container>
              <StyledResolucion.RowContainer item xs={6}>
                <StyledResolucion.FormikInput>
                  <FormikTextField
                    name="cantidad"
                    label="Cantidad Anual"
                    fullWidth
                  // disabled={hayUsoSinMedicion}
                  />
                </StyledResolucion.FormikInput>
              </StyledResolucion.RowContainer>

              <StyledResolucion.RowContainer item xs={6}>
                <StyledResolucion.FormikInput>
                  <FormikSelect
                    name="unidad"
                    label="Unidad de Medida"
                    fullWidth
                  // disabled={hayUsoSinMedicion}
                  >
                    {unidadesDeMedida.map(({ id, nombre }) => {
                      return (
                        <MenuItem value={id} key={id}>
                          {nombre}
                        </MenuItem>
                      );
                    })}
                    <MenuItem value={null} key="sinUnidad">
                      Sin unidad
                    </MenuItem>
                  </FormikSelect>
                </StyledResolucion.FormikInput>
              </StyledResolucion.RowContainer>
            </StyledResolucion.RowContainer>


            <Grid item xs={12} xl={6}>
              <UsosTableContainer />
            </Grid>

            <Grid item xs={12} xl={6}>
              <ProveedoresTableContainer />
            </Grid>
            <Grid item xs={12} xl={6}>
              <ProveedoresTableContainer esComprador={true} />
            </Grid>

            <Grid item xs={12}>
              <EquipoRadiologicoTableContainer />
            </Grid>

            <Grid item xs={12}>
              <EstudiosAmbientalesTableContainer />
            </Grid>
          </StyledResolucion.GridContainer>
          {stepper ?? ""}
          <StyledResolucion.ButtonContainer justifyContent="center" sx={{ p: '10px', }}>
            <FormikActions
              handleCancel={handleCancelSustancia}
              submit="Guardar sustancia"
            />
          </StyledResolucion.ButtonContainer>
        </Form>
      )}
    </Formik>
  );
};

export default DatosSustanciaForm;
